var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { runtime } from '../../../classes/runtime/Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { ChoiceOption } from '../../Choice/ChoiceOption/ChoiceOption';
import { Actor } from '../../../classes/actor/Actor';
import { AssociateOptionUI } from './modules/AssociateOptionUI';
export class AssociateOption extends ChoiceOption {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get associateOptionEdit() {
        return new runtime.solidPackages.Edit.classes.AssociateOptionEdit(this);
    }
    get associateOptionUI() {
        return new AssociateOptionUI(this);
    }
    get ownAssociations() {
        return this.question.allAssociations.filter(association => association.targetOptionNumber === this.optionNumber);
    }
    get shouldBeSelected() {
        if (!this.question.currentAssociation)
            return false;
        return this.ownAssociations.includes(this.question.currentAssociation);
    }
    set shouldBeSelected(isTrue) {
        if (!this.question.currentAssociation)
            return;
        this.question.currentAssociation.targetOptionNumber = this.optionNumber;
    }
    get isSelected() {
        if (!this.question.currentAssociation)
            return false;
        return this.question.currentAssociation.associatedOptionNumber === this.optionNumber;
    }
    set isSelected(isTrue) {
        if (!this.question.currentAssociation)
            return;
        if (isTrue) {
            this.question.currentAssociation.associatedDate = this.question.context.app.appClock.currentDate;
        }
        this.question.currentAssociation.associatedOptionNumber = this.optionNumber;
        if (this.question.currentAssociation.isWronglyAssociated) {
            this.question.answeringStepMistake.trackMistake();
        }
        if (this.question.currentAssociation.isCorrectlyAssociated) {
            this.question.answeringStepCorrect.trackCorrect();
        }
    }
    get associatedAssociations() {
        return this.ownAssociations.filter(association => association.isAssociationComplete);
    }
    selectOption() {
        if (!this.question.currentAssociation)
            return;
        if (this.optionNumber !== this.question.currentAssociation.targetOptionNumber &&
            this.question.numberOfTries > this.question.currentAssociation.numberOfFailedAttempts + 1) {
            this.question.currentAssociation.numberOfFailedAttempts++;
            this.question.currentAssociation.dateOfLatestFailedAttempt = this.question.context.app.appClock.currentDate;
            this.question.currentAssociation.failedOptionNumber = this.optionNumber;
            this.question.currentAssociation.actorEvents.fireEvent({ type: 'failedtry' });
            return;
        }
        this.isSelected = true;
        this.question.currentAssociation.actorEvents.fireEvent({ type: 'stepcomplete' });
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {},
        };
    }
    static get stripInfo() {
        return {
            extends: Actor.stripInfo,
            props: {},
        };
    }
}
__decorate([
    memoize
], AssociateOption.prototype, "associateOptionEdit", null);
__decorate([
    memoize
], AssociateOption.prototype, "associateOptionUI", null);
__decorate([
    override
], AssociateOption.prototype, "selectOption", null);
__decorate([
    memoize
], AssociateOption, "serializeInfo", null);
__decorate([
    memoize
], AssociateOption, "stripInfo", null);
